var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return (_vm.advName === "like_0" || _vm.advName === "like_2") && _vm.showAd
    ? _c(
        "div",
        {
          staticClass: "bigpic-ad sr-adv",
          attrs: {
            "data-mid": _vm.mid,
            "data-tplid": _vm.tplid,
            "data-name": _vm.advName,
            "data-w": _vm.w,
            "data-h": _vm.h,
            "data-vis": "0",
          },
        },
        [
          _vm.bigdata
            ? [
                _c(
                  "a",
                  {
                    attrs: {
                      href: _vm.bigdata[0].link,
                      uigs: "iadv_" + _vm.advName,
                    },
                    on: {
                      mousedown: function ($event) {
                        return _vm.cl(_vm.bigdata[0])
                      },
                    },
                  },
                  [
                    _c("div", { staticClass: "default-error-img" }, [
                      _c("img", {
                        attrs: {
                          src: _vm.checkHttps(_vm.bigdata[0].imglist[0]),
                          alt: "",
                        },
                      }),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "bigpic-ad-txt" }, [
                      _c("p", { staticClass: "bigpic-ad-txt-title" }, [
                        _vm._v(_vm._s(_vm.bigdata[0].title)),
                      ]),
                      _vm._v(" "),
                      _vm._m(0),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c("button", {
                  on: {
                    click: function ($event) {
                      _vm.showAd = false
                    },
                  },
                }),
              ]
            : _vm._e(),
        ],
        2
      )
    : _vm.advName === "midAdv" && _vm.showAd
    ? _c(
        "div",
        {
          staticClass: "sr-adv",
          attrs: {
            "data-mid": _vm.mid,
            "data-tplid": _vm.tplid,
            "data-vis": "0",
            "data-name": _vm.advName,
            "data-w": _vm.w,
            "data-h": _vm.h,
          },
        },
        [
          _vm.bigdata
            ? [
                _c(
                  "a",
                  {
                    staticClass: "sr-adv-lprt",
                    attrs: {
                      href: _vm.bigdata[0].link,
                      uigs: "iadv_" + _vm.advName,
                    },
                    on: {
                      mousedown: function ($event) {
                        return _vm.cl(_vm.bigdata[0])
                      },
                    },
                  },
                  [
                    _c("div", { staticClass: "sr-adv-lprt-info" }, [
                      _c("h4", [_vm._v(_vm._s(_vm.bigdata[0].title))]),
                      _vm._v(" "),
                      _c("p", [
                        _c("span", [_vm._v("广告")]),
                        _vm._v(" "),
                        _c("span", [_vm._v(_vm._s(_vm.bigdata[0].client))]),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "default-error-img sr-adv-lprt-img" },
                      [
                        _c("img", {
                          attrs: {
                            src: _vm.checkHttps(_vm.bigdata[0].imglist[0]),
                            alt: "",
                          },
                        }),
                      ]
                    ),
                  ]
                ),
              ]
            : _vm._e(),
        ],
        2
      )
    : _vm.advName === "relative" && _vm.showAd
    ? _c(
        "div",
        {
          staticClass: "sr-adv",
          attrs: {
            "data-mid": _vm.mid,
            "data-tplid": _vm.tplid,
            "data-vis": "0",
            "data-name": _vm.advName,
            "data-w": _vm.w,
            "data-h": _vm.h,
          },
        },
        [
          _vm.bigdata
            ? [
                _c(
                  "a",
                  {
                    attrs: {
                      href: _vm.bigdata[0].link,
                      uigs: "iadv_" + _vm.advName,
                    },
                    on: {
                      mousedown: function ($event) {
                        return _vm.cl(_vm.bigdata[0])
                      },
                    },
                  },
                  [
                    _c("div", { staticClass: "sr-adv-relative-img" }, [
                      _c("div", { staticClass: "default-error-img" }, [
                        _c("img", {
                          attrs: {
                            src: _vm.checkHttps(_vm.bigdata[0].imglist[0]),
                            alt: "",
                          },
                        }),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "sr-adv-tag-ad" }, [
                        _vm._v("广告"),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "sr-adv-relative-info" }, [
                      _c("p", [_vm._v(_vm._s(_vm.bigdata[0].title))]),
                    ]),
                  ]
                ),
              ]
            : _vm._e(),
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "bigpic-ad-txt-ad" }, [
      _c("span", [_vm._v("广告")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }